/**
 * 文案字典：id → {en, zh}。
 * 只收 UI 外壳文案；角色三件套说明、关卡/符卡/boss 专名、音乐曲目信息等内容数据不在这里。
 */
export const STRINGS = {
  // ---------------- 标题画面 ----------------
  'menu.start': { en: 'START GAME', zh: '开始游戏', ja: 'スタート', ko: '시작' },
  'menu.extra': { en: 'EXTRA', zh: '额外关', ja: 'エクストラ', ko: '추가' },
  'menu.replay': { en: 'REPLAY', zh: '回放', ja: 'リプレイ', ko: '리플레이' },
  'menu.leaderboard': { en: 'LEADERBOARD', zh: '排行榜', ja: 'ランキング', ko: '랭킹' },
  'menu.help': { en: 'HOW TO PLAY', zh: '操作说明', ja: '操作方法', ko: '조작 방법' },
  'menu.musicRoom': { en: 'MUSIC ROOM', zh: '音乐室', ja: 'ミュージックルーム', ko: '뮤직룸' },
  'title.disclaimer1': {
    en: 'Kimi is a trademark of Moonshot AI',
    zh: 'Kimi 为 Moonshot AI 商标，形象版权归 Moonshot AI 所有',
    ja: 'Kimi は Moonshot AI の商標です',
    ko: 'Kimi는 Moonshot AI의 상표입니다'
  },
  'title.disclaimer2': { en: 'CC-BY asset credits: see docs/04', zh: 'CC-BY 素材署名见 docs/04', ja: 'CC-BY 素材クレジットは docs/04 を参照', ko: 'CC-BY 에셋 크레딧: docs/04 참조' },
  'title.lang': { en: 'C: LANGUAGE', zh: 'C: LANGUAGE', ja: 'C: LANGUAGE', ko: 'C: LANGUAGE' },

  // 操作说明覆盖层
  'help.title': { en: 'HOW TO PLAY', zh: '操作说明', ja: '操作方法', ko: '조작 방법' },
  'help.move': { en: '↑↓←→   Move (fast by default)', zh: '↑↓←→   移动（默认高速）', ja: '↑↓←→   移動（デフォルト高速）', ko: '↑↓←→   이동 (기본 고속)' },
  'help.slow': { en: 'Shift   Slow move + show hitbox', zh: 'Shift   低速精密移动 + 显示判定点', ja: 'Shift   低速精密移動 + 判定表示', ko: 'Shift   저속 정밀 이동 + 판정 표시' },
  'help.shot': { en: 'Z       Shot (hold to auto-fire) / Confirm', zh: 'Z       射击（按住连发）/ 确认', ja: 'Z       ショット（長押し連射）/ 決定', ko: 'Z       샷 (홀드 연사) / 확인' },
  'help.bomb': { en: 'X       Bomb (press within 8 frames of a hit)', zh: 'X       炸弹（中弹后 8 帧内按=免死）', ja: 'X       ボム（被弾後 8 フレーム以内で耐え）', ko: 'X       폭탄 (피탄 후 8프레임 내 = 무사)' },
  'help.special': { en: 'C       Special (needs full gauge)', zh: 'C       特殊能力（槽满 100 可用）', ja: 'C       特殊能力（ゲージ 100 で使用可）', ko: 'C       특수 능력 (게이지 100 필요)' },
  'help.pause': { en: 'P / Esc Pause', zh: 'P / Esc 暂停', ja: 'P / Esc ポーズ', ko: 'P / Esc 일시정지' },
  'help.items': {
    en: 'Items: P Power / B Bomb / Point Score / Star Mult',
    zh: '道具：P 火力 / B 炸弹 / 点 计分 / 星 倍率',
    ja: 'アイテム：P 火力 / B ボム / 点 スコア / 星 倍率',
    ko: '아이템: P 화력 / B 폭탄 / 점 점수 / 별 배율'
  },
  'help.poc': {
    en: 'Move above the POC line to vacuum all items',
    zh: '移动到版面上方（POC 线）自动吸取全屏道具',
    ja: '画面上部（POC ライン）へ移動で全アイテム回収',
    ko: '화면 상단(POC 라인)으로 이동하면 전 아이템 흡수'
  },
  'help.graze': {
    en: 'Graze bullets for score and special gauge',
    zh: '擦弹（贴近敌弹）可涨分、攒特殊槽',
    ja: 'グレイズ（弾に近づく）でスコアと特殊ゲージアップ',
    ko: '그레이즈(탄에 근접)로 점수·특수 게이지 상승'
  },
  'help.back': { en: 'Z / X: Back', zh: 'Z / X：返回', ja: 'Z / X：戻る', ko: 'Z / X: 돌아가기' },

  // ---------------- 难度选择 ----------------
  'diff.title': { en: 'SELECT DIFFICULTY', zh: '选择难度', ja: '難易度選択', ko: '난이도 선택' },
  'diff.hint': { en: '↑↓ MOVE · Z CONFIRM · X BACK', zh: '↑↓ 移动 · Z 确认 · X 返回', ja: '↑↓ 移動 · Z 決定 · X 戻る', ko: '↑↓ 이동 · Z 확인 · X 돌아가기' },
  'diff.desc.easy': {
    en: 'Light, slow danmaku and simpler spell cards — for beginners',
    zh: '弹幕精简缓慢，符卡结构简化，适合初次接触弹幕游戏',
    ja: '軽めで遅い弾幕、簡単なスペルカード。初心者向け',
    ko: '가볍고 느린 탄막, 간단한 스펠카드 — 초보자용'
  },
  'diff.desc.normal': {
    en: 'The standard difficulty — danmaku in its full designed form',
    zh: '标准难度，关卡弹幕的完整设计形态',
    ja: '標準難易度。弾幕の完全な設計形態',
    ko: '표준 난이도 — 탄막의 완전한 설계 형태'
  },
  'diff.desc.hard': {
    en: 'Far more bullets and layers; spell cards gain new components',
    zh: '弹量与层数大幅增加，符卡追加新组件',
    ja: '弾数と層が大幅増加、スペルカードに新要素追加',
    ko: '탄량과 층 대폭 증가, 스펠카드에 새 요소 추가'
  },
  'diff.desc.lunatic': {
    en: 'Bullet hell: every pattern fully unleashed — for the strong',
    zh: '弹幕地狱：全结构强化形态，献给真正的强者',
    ja: '弾幕地獄：全パターン完全解放。強者向け',
    ko: '탄막 지옥: 모든 패턴 완전 항해 — 강자용'
  },
  'diff.desc.extra': {
    en: 'A single long boss fight, for those who cleared the game',
    zh: '单关长 boss 战，献给通关后的强者',
    ja: '単一の長いボス戦。クリアした強者向け',
    ko: '단일 긴 보스전 — 클리어한 강자용'
  },
  'diff.note': {
    en: 'Higher difficulties make the danmaku far more vicious',
    zh: '高难度下弹幕的构成会更加凶狠',
    ja: '高難易度ほど弾幕がより凶悪に',
    ko: '난이도가 높을수록 탄막이 더 흉악해집니다'
  },

  // ---------------- 选人 ----------------
  'char.title': { en: 'CHOOSE YOUR KIMI', zh: '选择你的 KIMI', ja: 'KIMI を選ぼう', ko: 'KIMI 선택' },
  'char.diffLabel': { en: 'DIFFICULTY: ', zh: '难度：', ja: '難易度：', ko: '난이도: ' },
  'char.hint': {
    en: 'ARROWS MOVE · Z CONFIRM · X BACK',
    zh: '方向键移动 · Z 确认 · X 返回难度选择',
    ja: '方向キー移動 · Z 決定 · X 難易度選択に戻る',
    ko: '방향키 이동 · Z 확인 · X 난이도 선택으로'
  },
  'char.shot': { en: 'SHOT', zh: '普攻', ja: 'ショット', ko: '샷' },
  'char.bomb': { en: 'BOMB', zh: '炸弹', ja: 'ボム', ko: '폭탄' },
  'char.special': { en: 'SPECIAL', zh: '特殊', ja: '特殊', ko: '특수' },

  // ---------------- 游戏内（结算卡 / 续关 / 暂停 / 浮字） ----------------
  'game.loading': { en: 'LOADING STAGE…', zh: '关卡加载中…', ja: 'ステージ読み込み中…', ko: '스테이지 로딩 중…' },
  'tally.allClear': { en: 'ALL CLEAR!', zh: 'ALL CLEAR!', ja: 'ALL CLEAR!', ko: 'ALL CLEAR!' },
  'tally.stageClear': { en: 'STAGE CLEAR!', zh: 'STAGE CLEAR!', ja: 'STAGE CLEAR!', ko: 'STAGE CLEAR!' },
  'tally.pointItems': { en: 'POINT ITEMS', zh: '点道具', ja: '点アイテム', ko: '점 아이템' },
  'tally.graze': { en: 'GRAZE', zh: '擦弹', ja: 'グレイズ', ko: '그레이즈' },
  'tally.spell': { en: 'SPELL CARD CAPTURE', zh: '符卡取得', ja: 'スペルカード取得', ko: '스펠카드 획득' },
  'tally.fragLine': { en: 'BOMB FRAGMENT +1 ({n}/3)', zh: '炸弹碎片 +1（{n}/3）', ja: 'ボムの欠片 +1（{n}/3）', ko: '폭탄 조각 +1 ({n}/3)' },
  'tally.fragMerge': { en: 'FRAGMENTS COMBINED: BOMB +1!', zh: '碎片合成：BOMB +1！', ja: '欠片合成：ボム +1！', ko: '조각 합성: 폭탄 +1!' },
  'tally.next': { en: 'Z: CONTINUE', zh: 'Z：继续', ja: 'Z：続ける', ko: 'Z: 계속' },
  'cont.zline': { en: 'Z: CONTINUE (SCORE RESETS, {n} LEFT)', zh: 'Z：续关（分数归零，剩余 {n} 次）', ja: 'Z：コンティニュー（スコアリセット、残り {n} 回）', ko: 'Z: 컨티뉴 (점수 초기화, {n}회 남음)' },
  'cont.xline': { en: 'X: END & SHOW RESULTS', zh: 'X：结束并结算', ja: 'X：終了して結果へ', ko: 'X: 종료 및 결과' },
  'pause.resume': { en: 'RESUME', zh: '继续', ja: '再開', ko: '계속' },
  'pause.restart': { en: 'RESTART STAGE', zh: '重开本关', ja: 'ステージをやり直す', ko: '스테이지 재시작' },
  'pause.toTitle': { en: 'BACK TO TITLE', zh: '回标题', ja: 'タイトルへ', ko: '타이틀로' },
  'float.shield': { en: 'SHIELD BLOCK!', zh: '护盾挡下！', ja: 'シールドガード！', ko: '실드 방어!' },
  'float.dream': { en: 'DREAM DODGE!', zh: '梦游回避！', ja: '夢幻回避！', ko: '몽유 회피!' },

  // ---------------- 总结算 ----------------
  'result.allClear': { en: 'ALL CLEAR!', zh: 'ALL CLEAR！', ja: 'ALL CLEAR!', ko: 'ALL CLEAR!' },
  'result.gameover': { en: 'GAME OVER', zh: 'GAME OVER', ja: 'GAME OVER', ko: 'GAME OVER' },
  'result.score': { en: 'SCORE', zh: 'SCORE 分数', ja: 'SCORE', ko: 'SCORE' },
  'result.graze': { en: 'GRAZE', zh: 'GRAZE 擦弹', ja: 'GRAZE', ko: 'GRAZE' },
  'result.maxPoint': { en: 'MAX POINT VALUE', zh: 'MAX POINT 点值上限', ja: 'MAX POINT VALUE', ko: 'MAX POINT VALUE' },
  'result.spell': { en: 'SPELL CARD', zh: 'SPELL CARD 符卡', ja: 'SPELL CARD', ko: 'SPELL CARD' },
  'result.continues': { en: 'CONTINUES', zh: 'CONTINUES 续关', ja: 'CONTINUES', ko: 'CONTINUES' },
  'result.stage': { en: 'STAGE', zh: 'STAGE 关卡', ja: 'STAGE', ko: 'STAGE' },
  'result.character': { en: 'CHARACTER', zh: 'CHARACTER 角色', ja: 'CHARACTER', ko: 'CHARACTER' },
  'result.difficulty': { en: 'DIFFICULTY', zh: 'DIFFICULTY 难度', ja: 'DIFFICULTY', ko: 'DIFFICULTY' },
  'result.cleared': { en: ' (CLEARED)', zh: '（通关）', ja: '（クリア）', ko: ' (클리어)' },
  'result.nameHint': {
    en: 'ENTER NAME FOR THE LEADERBOARD (Z SELECT · X DELETE · END SUBMIT)',
    zh: '输入名字登记排行榜（Z 选择 · X 删除 · END 提交）',
    ja: '名前を入力してランキング登録（Z 選択 · X 削除 · END 送信）',
    ko: '이름 입력해 랭킹 등록 (Z 선택 · X 삭제 · END 제출)'
  },
  'result.submitting': { en: 'SUBMITTING…', zh: '提交中…', ja: '送信中…', ko: '제출 중…' },
  'result.rankOk': { en: 'REGISTERED! CURRENT RANK: {n}', zh: '登记成功！当前排名：第 {n} 位', ja: '登録完了！現在の順位：{n} 位', ko: '등록 성공! 현재 순위: {n}위' },
  'result.fail': { en: 'SUBMIT FAILED: ', zh: '提交失败：', ja: '送信失敗：', ko: '제출 실패: ' },
  'result.back': { en: 'Z: BACK TO TITLE', zh: 'Z：回标题', ja: 'Z：タイトルへ', ko: 'Z: 타이틀로' },

  // ---------------- 排行榜 ----------------
  'lb.title': { en: 'LEADERBOARD', zh: '排行榜', ja: 'ランキング', ko: '랭킹' },
  'lb.hint': { en: '↑↓ Select · ←→ Diff · ⇧←→ Char · Z Play · C Stats · X Back', zh: '↑↓ 选择 · ←→ 难度 · ⇧←→ 角色 · Z 播放 · C 统计 · X 返回', ja: '↑↓ 選択 · ←→ 難易度 · ⇧←→ キャラ · Z 再生 · C 統計 · X 戻る', ko: '↑↓ 선택 · ←→ 난이도 · ⇧←→ 캐릭터 · Z 재생 · C 통계 · X 돌아가기' },
  'lb.noReplay': { en: 'No replay for this entry', zh: '该成绩没有录像', ja: 'この記録にはリプレイがありません', ko: '이 기록에는 리플레이가 없습니다' },
  'lb.replayOld': { en: 'Replay outdated (v{v}, current v{cur})', zh: '录像版本过旧（v{v}，当前 v{cur}）', ja: 'リプレイが古い（v{v}、現在 v{cur}）', ko: '리플레이 버전이 오래됨 (v{v}, 현재 v{cur})' },
  'rp.onlineOld': { en: 'Replay outdated (v{v}, current v{cur}) — cannot play', zh: '录像版本过旧（v{v}，当前 v{cur}），无法播放', ja: 'リプレイが古い（v{v}、現在 v{cur}）ため再生不可', ko: '리플레이 버전이 오래되어 (v{v}, 현재 v{cur}) 재생 불가' },

  // ---------------- 制作名单 ----------------
  'menu.options': { en: 'OPTIONS', zh: '选项', ja: 'オプション', ko: '옵션' },
  'opt.title': { en: 'OPTIONS', zh: '选项', ja: 'オプション', ko: '옵션' },
  'opt.sfx': { en: 'SFX VOLUME', zh: '音效音量', ja: '効果音音量', ko: '효과음 음량' },
  'opt.bgm': { en: 'MUSIC VOLUME', zh: '音乐音量', ja: 'BGM 音量', ko: '음악 음량' },
  'opt.lang': { en: 'LANGUAGE', zh: '语言', ja: '言語', ko: '언어' },
  'opt.mute': { en: 'MUTE', zh: '静音', ja: 'ミュート', ko: '음소거' },
  'opt.on': { en: 'ON', zh: '开', ja: 'ON', ko: 'ON' },
  'opt.off': { en: 'OFF', zh: '关', ja: 'OFF', ko: 'OFF' },
  'opt.hint': { en: '↑↓ Select · ←→ Adjust · Z/X Back', zh: '↑↓ 选择 · ←→ 调节 · Z/X 返回', ja: '↑↓ 選択 · ←→ 調整 · Z/X 戻る', ko: '↑↓ 선택 · ←→ 조절 · Z/X 돌아가기' },
  'opt.back': { en: 'Z/X: Back', zh: 'Z/X：返回', ja: 'Z/X：戻る', ko: 'Z/X: 돌아가기' },
  'menu.credits': { en: 'CREDITS', zh: '制作名单', ja: 'クレジット', ko: '크레딧' },
  'credits.game': { en: 'KIMI DANMAKU BATTLE', zh: 'KIMI 弹幕大作战', ja: 'KIMI 弾幕大作戦', ko: 'KIMI 탄막 대작전' },
  'credits.hint': { en: '↑↓ Speed · Z/X Skip', zh: '↑↓ 调速 · Z/X 跳过', ja: '↑↓ 速度 · Z/X スキップ', ko: '↑↓ 속도 · Z/X 건너뛰기' },
  'credits.endHint': { en: '— Z/X: Exit —', zh: '— Z/X：退出 —', ja: '— Z/X：終了 —', ko: '— Z/X: 나가기 —' },
  'credits.staff': { en: '— STAFF —', zh: '— 职员表 —', ja: '— スタッフ —', ko: '— 스태프 —' },
  'credits.director': { en: 'Director — Ahyangyi', zh: '总监（Director）— Ahyangyi', ja: 'ディレクター — Ahyangyi', ko: '디렉터 — Ahyangyi' },
  'credits.rDesign': { en: 'Game Design — Kimi K3 @ Kimi Code', zh: '游戏设计 — Kimi K3 @ Kimi Code', ja: 'ゲームデザイン — Kimi K3 @ Kimi Code', ko: '게임 디자인 — Kimi K3 @ Kimi Code' },
  'credits.rLevel': { en: 'Level Design — Kimi K3 @ Kimi Code', zh: '关卡设计 — Kimi K3 @ Kimi Code', ja: 'レベルデザイン — Kimi K3 @ Kimi Code', ko: '레벨 디자인 — Kimi K3 @ Kimi Code' },
  'credits.rProg': { en: 'Programming — Kimi K3 @ Kimi Code', zh: '程序 — Kimi K3 @ Kimi Code', ja: 'プログラミング — Kimi K3 @ Kimi Code', ko: '프로그래밍 — Kimi K3 @ Kimi Code' },
  'credits.rMusic': { en: 'Music Composition — Kimi K3 @ Kimi Code', zh: '作曲 — Kimi K3 @ Kimi Code', ja: '作曲 — Kimi K3 @ Kimi Code', ko: '작곡 — Kimi K3 @ Kimi Code' },
  'credits.rSfx': { en: 'Sound Effects — Kimi K3 @ Kimi Code', zh: '音效 — Kimi K3 @ Kimi Code', ja: '効果音 — Kimi K3 @ Kimi Code', ko: '음향 효과 — Kimi K3 @ Kimi Code' },
  'credits.rGfx': { en: 'Graphics (programmatic) — Kimi K3 @ Kimi Code', zh: '图形（程序化生成）— Kimi K3 @ Kimi Code', ja: 'グラフィック（プログラム生成） — Kimi K3 @ Kimi Code', ko: '그래픽(프로그래매틱) — Kimi K3 @ Kimi Code' },
  'credits.rQa': { en: 'QA & Testing — Kimi K3 @ Kimi Code', zh: '测试 — Kimi K3 @ Kimi Code', ja: 'QA・テスト — Kimi K3 @ Kimi Code', ko: 'QA 및 테스트 — Kimi K3 @ Kimi Code' },
  'credits.rI18n': { en: 'Localization — Kimi K3 @ Kimi Code', zh: '本地化 — Kimi K3 @ Kimi Code', ja: 'ローカライズ — Kimi K3 @ Kimi Code', ko: '현지화 — Kimi K3 @ Kimi Code' },
  'credits.rReplay': { en: 'Replay System — Kimi K3 @ Kimi Code', zh: '录像系统 — Kimi K3 @ Kimi Code', ja: 'リプレイシステム — Kimi K3 @ Kimi Code', ko: '리플레이 시스템 — Kimi K3 @ Kimi Code' },
  'credits.graphics': { en: '— ASSET SOURCES —', zh: '— 素材来源 —', ja: '— 素材出典 —', ko: '— 에셋 출처 —' },
  'credits.g1': {
    en: 'Monster sprites from: Dungeon Crawl Stone Soup tiles (CC0), via github.com/crawl/tiles & OpenGameArt',
    zh: '怪物图素材来自：Dungeon Crawl Stone Soup 图块（CC0），github.com/crawl/tiles 与 OpenGameArt',
    ja: 'モンスター画像： Dungeon Crawl Stone Soup タイル（CC0）、github.com/crawl/tiles と OpenGameArt より',
    ko: '몬스터 스프라이트: Dungeon Crawl Stone Soup 타일 (CC0), github.com/crawl/tiles 및 OpenGameArt'
  },
  'credits.g1b': {
    en: 'Authors of that tile pack (per its README): Eino Keskitalo · David Lawrence Ramsey · Enne Walker · David Ploog · Johanna Ploog · Denzi · Mitsuhiro Itakura · Robert Vollmert · Ixtli · dshaligram · Jesse Luehrs · Stefan O\'Rear · Jude Brown · abrahamwl · coolio · Adam Borowski · Porkchop · Purge · and the DCSS team',
    zh: '该素材包作者名单（见其 README）：Eino Keskitalo · David Lawrence Ramsey · Enne Walker · David Ploog · Johanna Ploog · Denzi · Mitsuhiro Itakura · Robert Vollmert · Ixtli · dshaligram · Jesse Luehrs · Stefan O\'Rear · Jude Brown · abrahamwl · coolio · Adam Borowski · Porkchop · Purge · 及 DCSS 团队',
    ja: '同タイルパックの作者（README より）：Eino Keskitalo · David Lawrence Ramsey · Enne Walker · David Ploog · Johanna Ploog · Denzi · Mitsuhiro Itakura · Robert Vollmert · Ixtli · dshaligram · Jesse Luehrs · Stefan O\'Rear · Jude Brown · abrahamwl · coolio · Adam Borowski · Porkchop · Purge · および DCSS チーム',
    ko: '해당 타일 팩 제작자(README 기준): Eino Keskitalo · David Lawrence Ramsey · Enne Walker · David Ploog · Johanna Ploog · Denzi · Mitsuhiro Itakura · Robert Vollmert · Ixtli · dshaligram · Jesse Luehrs · Stefan O\'Rear · Jude Brown · abrahamwl · coolio · Adam Borowski · Porkchop · Purge · 및 DCSS 팀'
  },
  'credits.g2': { en: 'Ship sprites from: Kenney Pixel Shmup (CC0)', zh: '战机素材来自：Kenney Pixel Shmup（CC0）', ja: '戦闘機画像： Kenney Pixel Shmup（CC0）', ko: '전투기 스프라이트: Kenney Pixel Shmup (CC0)' },
  'credits.g3': {
    en: 'Characters / bullets / items / UI — Kimi K3 @ Kimi Code',
    zh: '角色 / 弹丸 / 道具 / UI — Kimi K3 @ Kimi Code',
    ja: 'キャラクター / 弾 / アイテム / UI — Kimi K3 @ Kimi Code',
    ko: '캐릭터 / 탄 / 아이템 / UI — Kimi K3 @ Kimi Code'
  },
  'credits.music': { en: '— MUSIC —', zh: '— 音乐 —', ja: '— 音楽 —', ko: '— 음악 —' },
  'credits.m1': { en: 'All BGM composed by Kimi K3 @ Kimi Code', zh: '全部 BGM 由 Kimi K3 @ Kimi Code 作曲', ja: '全 BGM 作曲： Kimi K3 @ Kimi Code', ko: '모든 BGM 작곡: Kimi K3 @ Kimi Code' },
  'credits.m2': {
    en: 'Instrument samples from: Versilian Studios Chamber Orchestra 2 CE (CC0)',
    zh: '乐器采样来自：Versilian Studios Chamber Orchestra 2 CE（CC0）',
    ja: '楽器サンプル： Versilian Studios Chamber Orchestra 2 CE（CC0）',
    ko: '악기 샘플: Versilian Studios Chamber Orchestra 2 CE (CC0)'
  },
  'credits.m3': {
    en: 'SoundFont from: GeneralUser GS (S. Christian Collins, free to use)',
    zh: '音色库来自：GeneralUser GS（S. Christian Collins，免费使用）',
    ja: 'サウンドフォント： GeneralUser GS（S. Christian Collins、無料使用）',
    ko: '사운드폰트: GeneralUser GS (S. Christian Collins, 물료 사용)'
  },
  'credits.font': { en: '— FONT —', zh: '— 字体 —', ja: '— フォント —', ko: '— 글꼴 —' },
  'credits.f1': {
    en: 'Font from: Fusion Pixel Font — TakWolf & contributors (SIL OFL 1.1)',
    zh: '字体来自：缝合像素字体 — TakWolf 与贡献者们（SIL OFL 1.1）',
    ja: 'フォント： Fusion Pixel Font — TakWolf と貢献者たち（SIL OFL 1.1）',
    ko: '글꼴: Fusion Pixel Font — TakWolf 및 기여자들 (SIL OFL 1.1)'
  },
  'credits.bg': { en: '— BACKGROUNDS —', zh: '— 背景素材 —', ja: '— 背景素材 —', ko: '— 배경 에셋 —' },
  'credits.b1': {
    en: 'Backgrounds from: Clouds & Mountains (CC0) · Industrial (CC0) · Forest (CC0) · Halloween (CC0) · Space (CC0)',
    zh: '背景素材来自：云山（CC0）· 工业（CC0）· 森林（CC0）· 万圣（CC0）· 太空（CC0）',
    ja: '背景： 雲と山（CC0）· 工業（CC0）· 森（CC0）· ハロウィン（CC0）· 宇宙（CC0）',
    ko: '배경: 구름과 산 (CC0) · 인더스트리얼 (CC0) · 숲 (CC0) · 할로윈 (CC0) · 우주 (CC0)'
  },
  'credits.b2': {
    en: 'Underwater background from: Marc Russell (CC-BY 3.0), via OpenGameArt',
    zh: '水下背景来自：Marc Russell（CC-BY 3.0），OpenGameArt',
    ja: '水中背景： Marc Russell（CC-BY 3.0）、OpenGameArt より',
    ko: '수중 배경: Marc Russell (CC-BY 3.0), OpenGameArt'
  },
  'credits.trademark': { en: '— TRADEMARK —', zh: '— 商标 —', ja: '— 商標 —', ko: '— 상표 —' },
  'credits.tm': {
    en: 'Kimi is a trademark of Moonshot AI.',
    zh: 'Kimi 为 Moonshot AI 商标，形象版权归 Moonshot AI 所有。',
    ja: 'Kimi は Moonshot AI の商標です。',
    ko: 'Kimi는 Moonshot AI의 상표입니다.'
  },
  'credits.thanks': { en: 'Thanks for playing!', zh: '感谢游玩！', ja: 'プレイしてくれてありがとう！', ko: '플레이해 주셔서 감사합니다!' },
  'lb.allChars': { en: 'ALL CHARACTERS', zh: '全部角色', ja: '全キャラクター', ko: '전체 캐릭터' },
  'lb.loadFail': { en: 'LOAD FAILED: ', zh: '加载失败：', ja: '読み込み失敗：', ko: '로드 실패: ' },
  'lb.noServer': {
    en: '(MAKE SURE THE SERVER IS RUNNING: cd server && npm start)',
    zh: '（请确认服务器已启动：cd server && npm start）',
    ja: '（サーバー起動確認：cd server && npm start）',
    ko: '(서버 실행 확인: cd server && npm start)'
  },
  'lb.summary': {
    en: 'PLAYED {count} · BEST {best} · {clears} CLEARS',
    zh: '场次 {count} · 最高 {best} · 通关 {clears} 次',
    ja: '{count} 戦 · 最高 {best} · {clears} クリア',
    ko: '{count}회 · 최고 {best} · {clears} 클리어'
  },
  'lb.loading': { en: 'LOADING…', zh: '加载中…', ja: '読み込み中…', ko: '로딩 중…' },
  'lb.empty': { en: 'NO SCORES IN THIS FILTER — BE THE FIRST!', zh: '该条件下暂无成绩，快来抢头名！', ja: 'この条件の記録はまだありません。一番乗りを！', ko: '해당 조건 기록 없음 — 첫 기록에 도전!' },
  'lb.hRank': { en: '#', zh: '#', ja: '#', ko: '#' },
  'lb.hName': { en: 'NAME', zh: '名字', ja: '名前', ko: '이름' },
  'lb.hScore': { en: 'SCORE', zh: '分数', ja: 'スコア', ko: '점수' },
  'lb.hChar': { en: 'CHAR', zh: '角色', ja: 'キャラ', ko: '캐릭' },
  'lb.hDiff': { en: 'DIFF', zh: '难度', ja: '難易度', ko: '난이도' },
  'lb.hSt': { en: 'ST', zh: '面', ja: '面', ko: '면' },
  'lb.hClear': { en: 'CLEAR', zh: '通关', ja: 'クリア', ko: '클리어' },
  'lb.statsLoading': { en: 'LOADING STATS…', zh: '统计数据加载中…', ja: '統計読み込み中…', ko: '통계 로딩 중…' },
  'lb.statCell': { en: '{count}P · {clears}C', zh: '{count} 场 · {clears} 通', ja: '{count} 戦 · {clears} 通', ko: '{count}판 · {clears}클' },
  'lb.noStats': { en: 'NO STATS FOR THIS CHARACTER YET', zh: '该角色暂无统计数据', ja: 'このキャラの統計はまだありません', ko: '이 캐릭터 통계 없음' },

  // ---------------- 音乐室 ----------------
  'music.title': { en: 'MUSIC ROOM', zh: '音乐室', ja: 'ミュージックルーム', ko: '뮤직룸' },
  'music.sub': { en: '音乐室', zh: 'MUSIC ROOM', ja: 'ミュージックルーム', ko: '뮤직룸' },
  'music.hint': { en: '↑↓ SELECT · Z PLAY/STOP · X BACK', zh: '↑↓ 选择 · Z 播放/停止 · X 返回', ja: '↑↓ 選択 · Z 再生/停止 · X 戻る', ko: '↑↓ 선택 · Z 재생/정지 · X 돌아가기' },

  // ---------------- 回放列表 ----------------
  'rp.title': { en: 'REPLAY', zh: '回放', ja: 'リプレイ', ko: '리플레이' },
  'rp.sub': { en: '回放', zh: 'REPLAY', ja: 'リプレイ', ko: '리플레이' },
  'rp.tabLocal': { en: 'LOCAL', zh: '本地录像', ja: 'ローカル', ko: '로컬' },
  'rp.tabOnline': { en: 'ONLINE', zh: '在线录像', ja: 'オンライン', ko: '온라인' },
  'rp.hint': { en: '←→ TAB · ↑↓ SELECT · Z PLAY · X BACK', zh: '←→ 切换 · ↑↓ 选择 · Z 播放 · X 返回', ja: '←→ タブ · ↑↓ 選択 · Z 再生 · X 戻る', ko: '←→ 탭 · ↑↓ 선택 · Z 재생 · X 돌아가기' },
  'rp.emptyLocal': {
    en: 'NO LOCAL REPLAYS (SAVED AFTER EACH RUN)',
    zh: '暂无本地录像（完成一局后自动保存）',
    ja: 'ローカルリプレイなし（プレイ後自動保存）',
    ko: '로컬 리플레이 없음 (플레이 후 자동 저장)'
  },
  'rp.loading': { en: 'LOADING…', zh: '加载中…', ja: '読み込み中…', ko: '로딩 중…' },
  'rp.emptyOnline': { en: 'NO ONLINE REPLAYS', zh: '暂无在线录像', ja: 'オンラインリプレイなし', ko: '온라인 리플레이 없음' },
  'rp.verOld': {
    en: 'REPLAY VERSION TOO OLD (v{v}, CURRENT v{cur}) — CANNOT PLAY',
    zh: '录像版本过旧（v{v}，当前 v{cur}），无法播放',
    ja: 'リプレイバージョンが古い（v{v}、現在 v{cur}）ため再生不可',
    ko: '리플레이 버전이 오래되어 (v{v}, 현재 v{cur}) 재생 불가',
  },
  'rp.outdated': { en: 'OUTDATED VERSION — CANNOT PLAY', zh: '版本过旧，无法播放', ja: 'バージョンが古いため再生不可', ko: '버전이 오래되어 재생 불가' },

  // ---------------- 符卡练习 ----------------
  'menu.practice': { en: 'SPELL PRACTICE', zh: '符卡练习', ja: 'スペルプラクティス', ko: '스펠 연습' },
  'practice.title': { en: 'SPELL PRACTICE', zh: '符卡练习', ja: 'スペルプラクティス', ko: '스펠 연습' },
  'practice.hint': { en: '↑↓ Row · ←→ Value · Z Confirm · X Back', zh: '↑↓ 换行 · ←→ 换值 · Z 确认 · X 返回', ja: '↑↓ 行 · ←→ 値 · Z 決定 · X 戻る', ko: '↑↓ 행 · ←→ 값 · Z 확인 · X 돌아가기' },
  'practice.stage': { en: 'STAGE', zh: '关卡', ja: 'ステージ', ko: '스테이지' },
  'practice.boss': { en: 'BOSS', zh: 'BOSS', ja: 'ボス', ko: '보스' },
  'practice.mid': { en: 'MIDBOSS', zh: '道中 boss', ja: '道中ボス', ko: '도중 보스' },
  'practice.big': { en: 'STAGE BOSS', zh: '关底 boss', ja: 'ボス', ko: '최종 보스' },
  'practice.spell': { en: 'SPELL', zh: '符卡', ja: 'スペル', ko: '스펠' },
  'practice.diff': { en: 'DIFFICULTY', zh: '难度', ja: '難易度', ko: '난이도' },
  'practice.start': { en: 'START PRACTICE', zh: '开始练习', ja: '練習開始', ko: '연습 시작' },
  'practice.note': { en: 'Full power · 1 life · replay saved locally only', zh: '满火力 · 1 命 · 录像仅本地保存', ja: 'フルパワー · 残機 1 · リプレイはローカルのみ', ko: '풀 파워 · 1목숨 · 리플레이는 로컬에만 저장' },
  'practice.clear': { en: 'PRACTICE CLEAR', zh: '练习成功', ja: '練習成功', ko: '연습 성공' },
  'practice.failed': { en: 'PRACTICE FAILED', zh: '练习失败', ja: '練習失敗', ko: '연습 실패' },
  'practice.captured': { en: 'SPELL CAPTURED', zh: '符卡取得！', ja: 'スペル取得！', ko: '스펠 획득!' },
  'practice.nobonus': { en: 'DOWN (no bonus)', zh: '击破（未取得）', ja: '撃破（未取得）', ko: '격파 (미획득)' },
  'practice.retry': { en: 'Z: Retry · X: Back', zh: 'Z：再来一次 · X：返回', ja: 'Z：もう一度 · X：戻る', ko: 'Z: 재도전 · X: 돌아가기' },
  'help.fps': { en: 'F       Toggle FPS display', zh: 'F       切换 FPS 显示', ja: 'F       FPS 表示切替', ko: 'F       FPS 표시 전환' },
  'char.stats': { en: 'STATS', zh: '性能', ja: '性能', ko: '성능' },
  'char.statFast': { en: 'Fast', zh: '高速', ja: '高速', ko: '고속' },
  'char.statSlow': { en: 'Slow', zh: '低速', ja: '低速', ko: '저속' },
  'char.statMagnet': { en: 'Magnet', zh: '磁吸', ja: '磁吸', ko: '자석' },
  'char.statHitbox': { en: 'Hitbox', zh: '判定', ja: '判定', ko: '판정' },
  'mod.end': { en: 'EFFECT END', zh: '效果结束', ja: '効果終了', ko: '효과 종료' },
  'rp.cleared': { en: 'CLEARED', zh: '通关', ja: 'クリア', ko: '클리어' },
  'rp.prac': { en: 'PRAC', zh: '练习', ja: '練習', ko: '연습' },
  'hud.spellHistory': { en: 'HISTORY', zh: '历史', ja: '履歴', ko: '기록' },
  'float.cry': { en: 'WAAAH! ({n} to items)', zh: '哇——！（{n}颗变道具）', ja: 'わーん！（{n}個アイテムに）', ko: '으앙——! ({n}개 아이템으로)' },
  'float.charm': { en: 'LOOK AT ME~ ({n} to items)', zh: '看过来～（{n}颗变道具）', ja: '見て見て～（{n}個アイテムに）', ko: '여기 봐~ ({n}개 아이템으로)' },
  'spell.bonusLost': { en: 'BONUS LOST', zh: '奖励取消！', ja: 'ボーナス没収！', ko: '병과 취소!' },
  'rp.score': { en: 'SCORE ', zh: '分数 ', ja: 'スコア ', ko: '점수 ' },
};
